import type { OtherGroupIndexEntry } from '@/entities/market';
import type { SymbolKey } from '@/entities/symbol';
import { http } from '@/services/http';
import { enqueueIndexCall } from '@/services/http/indexQueuer';
import { toQueryParams } from '@/shared/lib/url/toQueryParams';

export const fetchOtherGroupIndex = async (
  key: SymbolKey,
  group: string,
  options?: { from?: string | null; to?: string | null }
): Promise<OtherGroupIndexEntry[]> => {
  const params = toQueryParams({
    code: key.Code,
    timeref: key.TimeRef,
    period: key.Period,
    periodtype: key.PeriodType,
    from: options?.from ?? '2v',
    to: options?.to || undefined,
    metadata: 'true',
    group
  });
  return enqueueIndexCall(() =>
    http.data
      .get<OtherGroupIndexEntry[]>(`/index${params}`, { headers: { Accept: 'application/json' } })
      .then(({ data }) => data)
  );
};
